import { render, staticRenderFns } from "./ipmanager.vue?vue&type=template&id=48788cd5&scoped=true&"
import script from "./ipmanager.vue?vue&type=script&lang=js&"
export * from "./ipmanager.vue?vue&type=script&lang=js&"
import style0 from "./ipmanager.vue?vue&type=style&index=0&id=48788cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48788cd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48788cd5')) {
      api.createRecord('48788cd5', component.options)
    } else {
      api.reload('48788cd5', component.options)
    }
    module.hot.accept("./ipmanager.vue?vue&type=template&id=48788cd5&scoped=true&", function () {
      api.rerender('48788cd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/merchant/ipmanager.vue"
export default component.exports